import React from 'react';

import { connect } from 'react-redux';

class AddFavoriteIcon extends React.Component {
  render() {
    return (
      <svg>
        <g transform="matrix(0.20639835,0,0,0.20639835,5.4,5.4)"><path
       d="m 209.521,13.251 c -23.354,0 -45.25,9.378 -61.264,25.25 C 132.244,22.628 110.348,13.251 86.993,13.251 39.025,13.251 0,52.277 0,100.245 c 0,38.813 14.157,73.226 44.553,108.299 18.824,21.721 61.054,52.392 84.552,68.742 5.728,3.984 12.438,5.977 19.15,5.977 6.715,0 13.43,-1.994 19.16,-5.98 23.496,-16.351 65.725,-47.021 84.545,-68.738 30.396,-35.071 44.554,-69.484 44.554,-108.299 0,-47.969 -39.026,-86.995 -86.993,-86.995 z m -62.885,211.434 c -40.825,0 -73.92,-33.095 -73.92,-73.92 0,-40.825 33.095,-73.921 73.92,-73.921 40.825,0 73.92,33.095 73.92,73.921 0,40.824 -33.095,73.92 -73.92,73.92 z"
       id="path5"
       fill={this.props.color || "#DE171F"}
       /><path
       d="m 166.636,130.764 0,-24.538 c 0,-11.046 -8.954,-20 -20,-20 -11.046,0 -20,8.954 -20,20 l 0,24.538 -24.538,0 c -11.046,0 -20,8.954 -20,20 0,11.046 8.954,20 20,20 l 24.538,0 0,24.538 c 0,11.046 8.954,20 20,20 11.046,0 20,-8.954 20,-20 l 0,-24.538 24.538,0 c 11.046,0 20,-8.954 20,-20 0,-11.046 -8.954,-20 -20,-20 l -24.538,0 z"
       id="path7"
       fill={this.props.color || "#DE171F"}
     /></g>
      </svg>
    );
  }
}

function mapStateToProps(state) {
  return {
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, undefined)(AddFavoriteIcon);


// 'use strict';
//
// Object.defineProperty(exports, "__esModule", {
//   value: true
// });
//
// var _react = require('react');
//
// var _react2 = _interopRequireDefault(_react);
//
// var _pure = require('recompose/pure');
//
// var _pure2 = _interopRequireDefault(_pure);
//
// var _SvgIcon = require('./SvgIcon');
//
// var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
//
// function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// var ActionAlarmOff = function ActionAlarmOff(props) {
//   return _react2.default.createElement(
//     _SvgIcon2.default,
//     props,
//     _react2.default.createElement('path', { d: 'm 209.521,13.251 c -23.354,0 -45.25,9.378 -61.264,25.25 C 132.244,22.628 110.348,13.251 86.993,13.251 39.025,13.251 0,52.277 0,100.245 c 0,38.813 14.157,73.226 44.553,108.299 18.824,21.721 61.054,52.392 84.552,68.742 5.728,3.984 12.438,5.977 19.15,5.977 6.715,0 13.43,-1.994 19.16,-5.98 23.496,-16.351 65.725,-47.021 84.545,-68.738 30.396,-35.071 44.554,-69.484 44.554,-108.299 0,-47.969 -39.026,-86.995 -86.993,-86.995 z m -62.885,211.434 c -40.825,0 -73.92,-33.095 -73.92,-73.92 0,-40.825 33.095,-73.921 73.92,-73.921 40.825,0 73.92,33.095 73.92,73.921 0,40.824 -33.095,73.92 -73.92,73.92 z', fill:"#DE171F" })
//   );
// };
// ActionAlarmOff = (0, _pure2.default)(ActionAlarmOff);
// ActionAlarmOff.displayName = 'ActionAlarmOff';
// ActionAlarmOff.muiName = 'SvgIcon';
//
// exports.default = ActionAlarmOff;



// WEBPACK FOOTER //
// ./src/icons/add-favorite.js